import { Stack } from "@fluentui/react";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { AppType, ChatAppResponse } from "../../api";
import i18next from "../../i18n/i18n";
import { RootState } from "../../Store";
import styles from "./Answer.module.css";
import { parseAnswerToHtml } from "./AnswerParser";
import { AnswerWithPreCodeDisplay } from "./AnswerWithPreCodeDisplay";
import { CitationList } from "./CitationList";

interface Props {
    allAnswer: ChatAppResponse;
    onCitationClicked: (filePath: string, citationIndex: number) => void;
    onFollowupQuestionClicked?: (question: string, appType: AppType) => void;
    onAttachmentLinkClick?: (filename: string, page?: number) => void;
    showFollowupQuestions?: boolean;
    FeedBackButtons?: React.ReactNode;
    warningMessage?: React.ReactNode;
    isStreaming: boolean;
    isFeedbackPage: boolean;
}

export const ALLNonTabContentRender: React.FC<Props> = ({
    allAnswer,
    onCitationClicked,
    onFollowupQuestionClicked,
    onAttachmentLinkClick,
    showFollowupQuestions,
    FeedBackButtons,
    warningMessage,
    isStreaming,
    isFeedbackPage
}) => {
    const allFollowupQuestions = allAnswer?.context?.followup_questions;
    const allDataPoints = allAnswer?.context?.data_points ?? [];
    const allMessageContent = typeof allAnswer?.output_text === "string" ? allAnswer?.output_text : "";
    const allFileMapping = allAnswer?.context?.file_mapping;
    const overAllCurrentSessionDataPoints = isFeedbackPage
        ? useSelector((store: RootState) => store.feedBackPage.overAllCurrentSessionDataPoints)
        : useSelector((store: RootState) => store.chatComponent.overAllCurrentSessionDataPoints);
    const allParsedAnswer = useMemo(
        () => parseAnswerToHtml(allMessageContent, isStreaming, onCitationClicked, allDataPoints, allFileMapping, "ALL", isFeedbackPage ? "Feedback" : "Chat"),
        [allAnswer, overAllCurrentSessionDataPoints.ALL]
    );
    return (
        <React.Fragment>
            <AnswerWithPreCodeDisplay
                sanitizedHTML={allParsedAnswer.answerHtml}
                onAttachmentLinkClick={(name, page) => onAttachmentLinkClick && onAttachmentLinkClick(name, page)}
            />

            <CitationList
                appType="ALL"
                citations={allParsedAnswer.citations}
                dataPoints={allDataPoints}
                onCitationClicked={onCitationClicked}
                onAttachmentLinkClick={onAttachmentLinkClick}
            />
            {!!warningMessage && warningMessage}
            {!!allFollowupQuestions?.length && showFollowupQuestions && onFollowupQuestionClicked && (
                <Stack.Item>
                    <Stack horizontal wrap className={`${!!allParsedAnswer.citations.length ? styles.followupQuestionsList : ""}`} tokens={{ childrenGap: 6 }}>
                        <span className={styles.followupQuestionLearnMore}>{i18next.t("answer.followupQuestions")}:</span>
                        {allFollowupQuestions.map((x: any, i: any) => {
                            return (
                                <a key={i} className={styles.followupQuestion} title={x} onClick={() => onFollowupQuestionClicked(x, "ALL")}>
                                    {`${x}`}
                                </a>
                            );
                        })}
                    </Stack>
                </Stack.Item>
            )}
            {!!FeedBackButtons && FeedBackButtons}
        </React.Fragment>
    );
};
